<div class="lm-columns-percent-row">
  <div *ngFor="let col of columns; trackBy: trackByIndex;" class="lm-columns-percent-column" [ngStyle]="{'width.%': (col.percent * 100)}">
    <lm-element
        *ngIf="col"
        [layoutObject]="col"
        [layoutInfo]="layoutInfo"
        [lmColumnLayoutInfo]="lmColumnLayoutInfo"
        [specFields]="specFields"
        [placeHolder]="placeHolder"
        [model]="model"
        (fieldEvent)="onFieldEvent($event)"
    ></lm-element>
  </div>
</div>

